import qs from 'qs';

import { STRINGIFY_OPTIONS } from '../common/utils/qsUtil';

export function getParameters(params: { [key: string]: string | number | undefined }): string {
    const queryParameters = qs.stringify(params, STRINGIFY_OPTIONS);
    return queryParameters ? `?${queryParameters}` : '';
}
